var map = {
	"./authorisation/routes.ts": 7691,
	"./dashboard/routes.ts": 6308,
	"./objectionRequest/routes.ts": 2352,
	"./profile/routes.ts": 9283,
	"./temporaryObjectionRequest/routes.ts": 2177
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9800;